import { useLoaderData } from 'react-router-dom';
import type { AboutContentDto } from '../application/dto/AboutContentDto';
import { useDocumentHead } from '../../../app/seo/useDocumentHead';
import { staticSeo } from '../../../app/seo/static-seo.content';
import { CompanyIntro } from './CompanyIntro';
import { MissionVision } from './MissionVision';
import { CoreValues } from './CoreValues';
import { CeoMessage } from './CeoMessage';
import { Timeline } from './Timeline';
import { Statistics } from './Statistics';
import { WhyChooseUs } from './WhyChooseUs';
import { Certifications } from './Certifications';
import { StrategicGoals } from './StrategicGoals';
import { Licenses } from './Licenses';
import { Leadership } from './Leadership';
import { AboutCTA } from './AboutCTA';

export function AboutPage() {
  const content = useLoaderData() as AboutContentDto;
  useDocumentHead(staticSeo.about);

  return (
    <>
      <CompanyIntro introduction={content.introduction} story={content.story} />
      <MissionVision mission={content.mission} vision={content.vision} />
      <StrategicGoals goals={content.strategicGoals} />
      <CoreValues values={content.coreValues} />
      <Statistics items={content.statistics} />
      <Leadership members={content.leadership} />
      <Licenses licenses={content.licenses} />
      <CeoMessage message={content.ceoMessage} ceoName={content.ceoName} />
      <Timeline events={content.timeline} />
      <WhyChooseUs reasons={content.whyChooseUs} />
      <Certifications certifications={content.certifications} />
      <AboutCTA label={content.ctaLabel} href={content.ctaHref} />
    </>
  );
}
